import { createRouter, createWebHistory } from 'vue-router';
import Login from 'views/auth/login.vue';
import Signup from 'views/auth/sign-up.vue';
import Home from 'views/home.vue';
import Splash from 'views/splash.vue';
import NotFound from 'views/not-found.vue';
import { useContextStore } from 'store/context.js';
import ForgotPassword from 'views/auth/forgot-password.vue';
import Auth from 'views/auth/auth.vue';
import Week from 'views/week.vue';
import HomeIndex from 'components/home/home-index.vue';

const routes = [
    {
        path: '/',
        name: 'splash',
        component: Splash,
        meta: { public: true },
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { public: true },
    },
    {
        path: '/sign-up',
        name: 'sign-up',
        component: Signup,
        meta: { public: true },
    },
    {
        path: '/auth',
        name: 'auth',
        component: Auth,
        meta: { public: true },
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: { public: true },
    },
    {
        path: '/404',
        name: '404',
        component: NotFound,
        meta: { public: true },
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '404',
    },
    {
        path: '/home',
        component: Home,
        redirect: '/home/today',
        children: [
            { path: 'today', name: 'today', component: HomeIndex },
            { path: 'week', name: 'week', component: Week },
        ],
    },
];

export const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {
    const publicAccess = to.matched.some((record) => record.meta.public) ?? false;
    const context = useContextStore();

    if (!publicAccess && !context.authenticated) {
        console.log(' - Not authenticated, go to login');
        return next({ name: 'login', replace: true });
    }

    if (to.name === 'splash' && context.authenticated) {
        return next({ name: 'today', replace: true });
    }

    next();
});
